import TransferForm from './TransferFormContainer';

export default TransferForm;
